import { useState } from "react";
import { Form, Formik } from "formik";
import { object, string } from "yup";
// @ts-expect-error pure js
import TextInput from "../UI/TextInput";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import Callout from "../UI/Callout";
import ModalDialog, {
  ModalDialogBody,
  ModalDialogFooter,
} from "../UI/ModalDialog";
// @ts-expect-error pure js
import { handleAPIError } from "../../utils";
// @ts-expect-error pure js
import { sanitizeValues } from "../../models/utils";
import styles from "./AccountNumbersForm.module.css";

export interface AccountNumberField {
  name: string;
  label: string;
  placeholder?: string;
}

export type AccountNumberValues = Record<string, string | null>;

interface AccountNumbersFormProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  header: string;
  subtitle: string;
  fields: AccountNumberField[];
  initialValues: AccountNumberValues;
  onSubmit: (values: AccountNumberValues) => Promise<void>;
}

const ACCOUNT_NUMBER_MESSAGE = "1 à 20 lettres ou chiffres, sans espace";

const accountNumberSchema = string()
  .nullable()
  .matches(/^[A-Za-z0-9]*$/, ACCOUNT_NUMBER_MESSAGE)
  .max(20, ACCOUNT_NUMBER_MESSAGE);

export default function AccountNumbersForm({
  open,
  onOpenChange,
  header,
  subtitle,
  fields,
  initialValues,
  onSubmit,
}: AccountNumbersFormProps) {
  const [error, setError] = useState("");

  const validationSchema = object(
    Object.fromEntries(
      fields.map((field) => [field.name, accountNumberSchema]),
    ),
  );

  return (
    <Formik<AccountNumberValues>
      initialValues={Object.fromEntries(
        fields.map((field) => [field.name, initialValues[field.name] ?? ""]),
      )}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={async (values) => {
        setError("");
        try {
          await onSubmit(sanitizeValues(values));
          onOpenChange(false);
        } catch (e) {
          setError(handleAPIError(e));
        }
      }}
    >
      {({ resetForm }) => (
        <ModalDialog
          size="sm"
          open={open}
          header={header}
          subtitle={subtitle}
          onOpenChange={(nextOpen) => {
            if (!nextOpen) {
              resetForm();
              setError("");
            }
            onOpenChange(nextOpen);
          }}
        >
          <Form>
            <ModalDialogBody className={styles.form}>
              {fields.map((field) => (
                <TextInput
                  key={field.name}
                  type="text"
                  name={field.name}
                  label={field.label}
                  placeholder={field.placeholder}
                  marginForm=""
                />
              ))}
              <Callout variant="danger">{error}</Callout>
            </ModalDialogBody>
            <ModalDialogFooter>
              <FormikSubmitButton requiresWrite>Enregistrer</FormikSubmitButton>
            </ModalDialogFooter>
          </Form>
        </ModalDialog>
      )}
    </Formik>
  );
}
